import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { WORK_ORDER_STATUS_COLORS } from 'settings/constants/workOrder'

/**
 * Renders a status bar at the bottom of a calendar day cell
 * Shows colored segments for multiple work order statuses
 */
const CalendarDayStatusBar = ({ dateStr, workOrderStatuses }) => {
  const theme = useTheme()

  if (!workOrderStatuses || workOrderStatuses.length <= 1) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '4px',
        display: 'flex',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        overflow: 'hidden',
      }}
    >
      {workOrderStatuses.map(status => (
        <Box
          key={`${dateStr}-status-${status}`}
          sx={{
            flex: 1,
            backgroundColor: WORK_ORDER_STATUS_COLORS[status] || theme.palette.grey[300],
          }}
        />
      ))}
    </Box>
  )
}

CalendarDayStatusBar.propTypes = {
  dateStr: PropTypes.string.isRequired,
  workOrderStatuses: PropTypes.arrayOf(PropTypes.string),
}

export default CalendarDayStatusBar
